import { useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { useAuth } from '../../auth/AuthProvider.jsx';
import { api } from '../../api/client.js';
import { ApiError } from '../../api/client.js';
import { Card } from '../../components/ui/Card.jsx';
import { Input } from '../../components/ui/Input.jsx';
import { Button } from '../../components/ui/Button.jsx';
import { Badge } from '../../components/ui/Badge.jsx';
import { PageHeader } from '../../components/ui/PageHeader.jsx';
import { applyServerValidation } from '../../lib/forms.js';
import { t } from '../../lib/i18n.js';

export function ProfilePage() {
  const { user, refresh } = useAuth();

  const { register, handleSubmit, setError, formState: { errors } } = useForm({
    defaultValues: {
      firstName: (user && user.firstName) || '',
      lastName: (user && user.lastName) || ''
    }
  });

  const mutation = useMutation({
    mutationFn: (values) => api.patch('/me', values),
    onSuccess: async () => {
      toast.success('Profilo aggiornato.');
      await refresh();
    },
    onError: (err) => {
      const applied = applyServerValidation(err, setError);
      if (!applied) toast.error(err instanceof ApiError ? err.message : t('common.error'));
    }
  });

  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="Il tuo profilo" description="Aggiorna i dati personali. Email e password si gestiscono dal pannello admin." />

      <Card className="max-w-xl">
        <form className="flex flex-col gap-4" onSubmit={handleSubmit(mutation.mutate)} noValidate>
          <Input label="Email" disabled value={user?.email || ''} />
          <div className="flex items-center gap-2">
            <span className="text-xs text-ink-muted">MFA</span>
            <Badge tone={user?.mfaEnabled ? 'success' : 'warning'}>{user?.mfaEnabled ? 'Abilitata' : 'Non abilitata'}</Badge>
          </div>
          <Input label="Nome" error={errors.firstName?.message} {...register('firstName', { maxLength: { value: 120, message: 'massimo 120 caratteri' } })} />
          <Input label="Cognome" error={errors.lastName?.message} {...register('lastName', { maxLength: { value: 120, message: 'massimo 120 caratteri' } })} />
          <div className="flex justify-end">
            <Button type="submit" loading={mutation.isPending}>{t('common.save')}</Button>
          </div>
        </form>
      </Card>
    </div>
  );
}
